import { Guid } from '@web/utils';
import { WarehouseGoodType } from '../enums/warehouse-good-type';

export class WarehouseGoodConnectedObject {
  public constructor(
    private readonly data: {
      id: Guid;
      type: WarehouseGoodType;
      name: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get type(): WarehouseGoodType {
    return this.data.type;
  }

  public get name(): string {
    return this.data.name;
  }
}
